import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text,
  Box,
  ChakraProvider,
} from '@chakra-ui/react'

interface AlertModalProps {
  open: boolean
  message: string
  title?: string
  close: () => void
}

const AlertModal: React.FC<AlertModalProps> = ({
  open,
  title,
  message,
  close,
}) => {
  return (
    <ChakraProvider>
      <Modal isOpen={open} onClose={close} isCentered size="xs">
        <ModalOverlay />
        <ModalContent maxW="364px">
          <ModalHeader
            borderBottom="none"
            fontFamily="Instrument Serif"
            fontSize="24px"
            fontWeight="400"
            lineHeight="100%"
            pt="20px"
            px="20px"
            pb="16px"
            color="var(--blue-dark)"
          >
            {title}
            <ModalCloseButton fontWeight="400" color="#9091A4" />
          </ModalHeader>

          <ModalBody px="20px" pb="20px" pt="0">
            <Box width="100%">
              <Text
                fontSize="14px"
                fontWeight="400"
                lineHeight="1.1"
                fontFamily="Inter"
                mb="0"
                color="#1B294D"
              >
                {message}
              </Text>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </ChakraProvider>
  )
}

export default AlertModal
